/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import findIndex from 'lodash/findIndex';
import { createSelector } from 'reselect';
import PRODUCTDETAIL_CONSTANTS from '@tcp/core/src/components/features/browse/ProductDetail/container/ProductDetail.constants';
import {
  getIsGuest,
  isPlccUser,
} from '@tcp/core/src/components/features/account/User/container/User.selectors';
import { getDynamicContentPDP } from '@tcp/core/src/reduxStore/selectors/session.selectors.js';
import { getAppliedFilters } from '@tcp/core/src/components/features/browse/ProductListing/container/ProductListing.selectors';
import { getMapSliceForColorProductId } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/utils/productsCommonUtils.js';
import { getABtestFromState, isServer } from '../../../../../utils';
import getAddedToBagFormValues from '../../../../../reduxStore/selectors/form.selectors';
import { processBreadCrumbs } from '../../ProductListing/container/ProductListing.util';
import { getProductDetails } from '../../../CnC/CartItemTile/container/CartItemTile.selectors';
import {
  fetchBreadCrumbs,
  getAppliedFilters as getCategoryListingFilters,
} from '../../CategoryListingPage/container/CategoryListingPage.selectors';
import {
  getHplpAppliedFilters,
  isHplp,
} from '../../HorizontalCategory/container/HorizontalCategory.selectors';
import processHelperUtil from '../../../../../services/abstractors/productListing/ProductDetail.util';
import { getDynamicLabelValues } from '../../../../../utils/labels/labelUtilty';

export const getNavTree = (state) => {
  return state && state.Navigation.navigationData;
};
/*
const selectSelf = (state) =>  state;
export const prodDetails = createSelector( selectSelf, (state) => state.ProductDetail);
*

/*
export const prodDetails = (state) => {
  return state.ProductDetail;
};
*/

const getProdDetailNewMemo = (state) => {
  return state.ProductDetail;
};

export const prodDetailsMobile = createSelector(
  getProdDetailNewMemo,
  (prodDetailsDta) => prodDetailsDta
);

export const getCurrentProduct = createSelector(
  (state) => state.ProductDetail?.currentProduct,
  (currentProduct) => currentProduct
);

export const getSimilarProducts = createSelector(
  (state) => state.ProductDetail?.similarProducts || [],
  (similarProducts) => similarProducts
);
export const getSimilarProductsModalStatus = createSelector(
  (state) => state.ProductDetail?.isSimilarProductsModalOpen || false,
  (isSimilarProductsModalOpen) => isSimilarProductsModalOpen
);

const getState = (state) => state;

export const getActiveTabSection = createSelector(
  getState,
  (state) => state?.ProductDetail?.activeTabSection
);

const getCurrentProductDynamicData = createSelector(
  (state) => state.ProductDetail?.currentProductDynamicData,
  (currentProductDynamicData) => currentProductDynamicData
);

export const prodDetails = createSelector(
  getCurrentProduct,
  getCurrentProductDynamicData,
  (currentProduct, currentProductDynamicData) => ({ currentProduct, currentProductDynamicData })
);

export const getMultiPackProductInfo = (state) => {
  return state && state.ProductDetail.newPartNumber;
};

export const getMultiPackCount = (state) => {
  return state && state.ProductDetail.multiPackCount;
};

export const getSocialProofMessage = (state) => {
  return state && state?.ProductDetail?.socialProofData?.socialProofMsg;
};

export const getSinglePageLoad = (state) => {
  return state && state.ProductDetail.singlepageload;
};

export const getInitialMultipackMapping = (state) => {
  return state && state.ProductDetail && state.ProductDetail.availableTCPMultipackProductMapping;
};

export const getInitialColorConsolidationMultipackMapping = (state) => {
  return (
    state && state.ProductDetail && state.ProductDetail.availableColorConsolidationTCPmapNewStyleId
  );
};

export const getInitialAvailableTCPmapNewStyleId = (state) => {
  return state && state.ProductDetail && state.ProductDetail.availableTCPmapNewStyleId;
};

export const getInitialTCPStyleQTY = (state) => {
  return state && state.ProductDetail && state.ProductDetail.initialSelectedQty;
};

export const getAllMultiPackData = (state) => {
  return state && state.ProductDetail.getMultiPackAllColor;
};

export const getAllNewMultiPackData = (state) => {
  return state && state.ProductDetail && state.ProductDetail.getNewMultiPackAllColor;
};

export const partIdInformation = (state) => {
  return state && state.ProductDetail && state.ProductDetail.partIdDetail;
};

const getProductListingBreadCrumbTrail = createSelector(
  (state) => state.ProductListing?.breadCrumbTrail,
  (breadCrumbTrail) => breadCrumbTrail
);
const getProductDetailsBreadCrumb = createSelector(
  (state) => {
    return state.ProductDetail?.breadCrumbs;
  },
  (productDetail) => productDetail
);

const getIsFromCategoryPage = (_, query) => {
  return query?.referer === 'categoryPage';
};
export const getBreadCrumbs = createSelector(
  getProductListingBreadCrumbTrail,
  getProductDetailsBreadCrumb,
  (productListingBreadCrumbTrail, ProductDetailBreadCrumbs) => {
    let breadCrumbsData;
    const homeBreadCrumb = {
      destination: 'c',
      displayName: 'Home',
      pathSuffix: 'home',
    };
    if (productListingBreadCrumbTrail) {
      breadCrumbsData = processBreadCrumbs(productListingBreadCrumbTrail);
    }
    breadCrumbsData = ProductDetailBreadCrumbs;

    if (breadCrumbsData) {
      const filteredBreadcrumbArray = breadCrumbsData.filter((item) => {
        return item.displayName === 'Home';
      });
      const isHomeBreadCrumbAvailable =
        filteredBreadcrumbArray && filteredBreadcrumbArray.length > 0;
      if (!isHomeBreadCrumbAvailable) {
        breadCrumbsData.unshift(homeBreadCrumb);
      }
    }
    return breadCrumbsData;
  }
);

export const getNavBreadCrumbs = createSelector(
  getBreadCrumbs,
  fetchBreadCrumbs,
  getIsFromCategoryPage,
  (oldBreadCrumbs, newBreadCrumbs, isFromCategoryPage) => {
    if (isFromCategoryPage) return newBreadCrumbs;
    return oldBreadCrumbs;
  }
);
export const getSelectedMultipack = (state) => {
  return state && state.ProductDetail && state.ProductDetail.selectedMultipack;
};

export const getDisableMultiPackTab = (state) => {
  return state && state.ProductDetail && state.ProductDetail.disabledTab;
};

export const getProductInfoFromRecommendationData = ({ pid, details, dataSource }) => {
  try {
    const [...recKeys] = details.keys();
    let productData = {};
    let finalProductData = {};
    recKeys.forEach((recKey) => {
      const prodObj = details.get(recKey, null);
      productData =
        prodObj &&
        prodObj.products.find(
          (product) => product && product.productInfo && product.productInfo.uniqueId === pid
        );
      if (productData) {
        finalProductData = productData;
      }
    });

    const {
      productInfo: {
        uniqueId,
        name,
        listPrice,
        offerPrice,
        priceRange,
        isGiftCard,
        tcpStyleQty,
        tcpStyleType,
        hardMarkDown,
        primaryBrand,
        ratings,
        reviewsCount,
      } = {},
      colorsMap,
      imagesByColor,
    } = finalProductData;
    return {
      uniqueId,
      name,
      colorFitsSizesMap: colorsMap,
      imagesByColor,
      listPrice,
      offerPrice,
      priceRange,
      isGiftCard,
      tcpStyleQty,
      tcpStyleType,
      hardMarkDown,
      dataSource,
      primaryBrand,
      ratings,
      reviewsCount,
    };
  } catch (err) {
    return null;
  }
};

export const getProductInfoFromModule = ({ pid, details }) => {
  try {
    const productData = details.find((product) => product && product.uniqueId === pid);
    const { uniqueId, product_name: productName, imageUrl } = productData;
    return {
      uniqueId,
      name: productName,
      colorFitsSizesMap: [],
      imagesByColor: imageUrl,
      productInfo: [],
    };
  } catch (err) {
    return null;
  }
};

export const getProductInfoFromOutfit = ({ pid, details }) => {
  try {
    const {
      productId,
      name,
      listPrice,
      offerPrice,
      colorFitsSizesMap,
      imagesByColor,
      highListPrice,
      highOfferPrice,
      lowListPrice,
      lowOfferPrice,
      onlyListPrice,
      TCPStyleQTY,
      TCPStyleType,
      hardMarkDown,
    } = details.find((product) => product && product.productId === pid);
    return {
      uniqueId: productId,
      name,
      colorFitsSizesMap,
      imagesByColor,
      listPrice,
      offerPrice,
      priceRange: {
        highListPrice,
        highOfferPrice,
        lowListPrice,
        lowOfferPrice,
        onlyListPrice,
      },
      TCPStyleQTY,
      TCPStyleType,
      hardMarkDown,
    };
  } catch (err) {
    return null;
  }
};

export const getProductInfoFromBundle = ({ pid, details }) => {
  try {
    let selectedProductIndex = 0;
    details.forEach((item, index) => {
      const productIndex = findIndex(item.products && item.products.colorFitsSizesMap, {
        colorDisplayId: pid,
      });
      if (productIndex > -1) {
        selectedProductIndex = index;
      }
    });
    const productList = details && details[selectedProductIndex].products.colorFitsSizesMap;
    const imagesByColor = details && details[selectedProductIndex].products.imagesByColor;
    const currentColorEntry = getMapSliceForColorProductId(productList, pid);
    const hardMarkDown = currentColorEntry && currentColorEntry.hardMarkDown;

    const {
      colorDisplayId,
      name,
      listPrice,
      offerPrice,
      priceRange,
      miscInfo: { badge2 },
      color,
    } = productList.find((product) => product && product.colorDisplayId === pid);
    return {
      uniqueId: colorDisplayId,
      name,
      colorFitsSizesMap: [{ color: { ...color, colorDisplayId } }],
      imagesByColor,
      listPrice,
      offerPrice,
      priceRange,
      badge2,
      hardMarkDown,
    };
  } catch (err) {
    return null;
  }
};

export const getSingleProductInfo = (selectedProduct) => {
  if (selectedProduct) {
    const {
      productInfo: {
        uniqueId,
        name,
        listPrice,
        offerPrice,
        priceRange,
        isGiftCard,
        tcpStyleQty,
        tcpStyleType,
        ratings,
        reviewsCount,
        unbxdRatings,
        unbxdReviewsCount,
        primaryBrand,
        hardMarkDown,
        promotionalMessage,
        promotionalPLCCMessage,
        TCPPromotionID,
        TCPPromotionPrice,
        variantTotal,
      },
      colorsMap,
      imagesByColor,
      miscInfo,
    } = selectedProduct;
    const { isStoreSpecialEligible } = miscInfo || {};
    const selectedProductMiscInfo = colorsMap?.[0]?.miscInfo;
    return {
      uniqueId,
      name,
      colorFitsSizesMap: colorsMap,
      imagesByColor,
      listPrice,
      offerPrice,
      priceRange,
      isGiftCard,
      tcpStyleQty,
      tcpStyleType,
      reviewsCount,
      ratings,
      unbxdReviewsCount,
      unbxdRatings,
      badge1: selectedProductMiscInfo?.badge1?.defaultBadge,
      primaryBrand,
      hardMarkDown,
      promotionalMessage,
      promotionalPLCCMessage,
      TCPPromotionID,
      TCPPromotionPrice,
      variantTotal,
      isStoreSpecialEligible,
    };
  }
  return null;
};

const getIsMatching = (initalValue, valueToCompare) => initalValue === valueToCompare;

const getSelectedProductIndex = (item, index, pid, selectedProductIndex) => {
  if (getIsMatching(item?.uniqueId, pid)) {
    return index;
  }
  const productIndex = findIndex(item, { uniqueId: pid });
  if (productIndex > -1) {
    return index;
  }
  return selectedProductIndex;
};

// eslint-disable-next-line sonarjs/cognitive-complexity
export const getProductInfoFromProductListingData = ({ pid, details, type }) => {
  try {
    let selectedProductIndex = 0;
    let selectedProduct = {};
    if (type === 'mbox_Recommendation') {
      details.forEach((item, index) => {
        if (getIsMatching(item.uniqueId, pid)) {
          selectedProductIndex = index;
          selectedProduct = item;
        }
      });
    } else {
      details.forEach((item, index) => {
        selectedProductIndex = getSelectedProductIndex(item, index, pid, selectedProductIndex);
      });
      const productList = details?.[selectedProductIndex];
      if (!Array.isArray(productList)) {
        selectedProduct = productList;
      } else {
        selectedProduct = productList?.find((product) => product?.productInfo?.uniqueId === pid);
      }
    }
    return getSingleProductInfo(selectedProduct);
  } catch (err) {
    return null;
  }
};

export const getProductInfoFromCart = ({ pid, details }) => {
  try {
    const selectedProductFromCart = details.find((product) => {
      const modifiedProductKeys = getProductDetails(product);
      const { productInfo } = modifiedProductKeys;
      if (productInfo.productPartNumber === pid) return true;
      return false;
    });
    const {
      productInfo: { productPartNumber, tcpStyleQty, tcpStyleType },
      itemInfo: { listPrice, offerPrice, name, imagePath, color },
      miscInfo,
    } = getProductDetails(selectedProductFromCart);

    return {
      uniqueId: productPartNumber,
      name,
      listPrice,
      offerPrice,
      tcpStyleQty,
      tcpStyleType,
      hardMarkDown: miscInfo?.clearanceItem,
      colorFitsSizesMap: [
        {
          colorProductId: productPartNumber,
          imageName: productPartNumber,
          productImage: imagePath.split('/')[1],
          miscInfo,
          color: { name: color },
        },
      ],
      imagesByColor: {
        [color]: {
          basicImageUrl: imagePath,
          extraImages: [
            {
              isShortImage: false,
              isOnModalImage: false,
              iconSizeImageUrl: imagePath,
              listingSizeImageUrl: imagePath,
              regularSizeImageUrl: imagePath,
              bigSizeImageUrl: imagePath,
              superSizeImageUrl: imagePath,
            },
          ],
        },
        listPrice,
        offerPrice,
      },
    };
  } catch (error) {
    return null;
  }
};

export const getAlternateSizes = (state) => {
  return state.ProductDetail.currentProduct && state.ProductDetail.currentProduct.alternateSizes;
};
export const getAlternateStyles = (state) => {
  return state.ProductDetail && state.ProductDetail.alternateStyles;
};
export const getDescription = (state) => {
  return state.ProductDetail.currentProduct && state.ProductDetail.currentProduct.longDescription;
};

export const getRatingsProductId = (state) => {
  return state.ProductDetail.currentProduct && state.ProductDetail.currentProduct.ratingsProductId;
};

export const getGeneralProductId = (state) => {
  return state.ProductDetail.currentProduct && state.ProductDetail.currentProduct.generalProductId;
};

export const getShortDescription = (state) => {
  return state.ProductDetail.currentProduct && state.ProductDetail.currentProduct.shortDescription;
};

export const getPrimaryBrand = (state) => {
  return state.ProductDetail.currentProduct && state.ProductDetail.currentProduct.primaryBrand;
};

export const getPDPLoadingState = (state) => {
  return state.ProductDetail && state.ProductDetail.isLoading;
};

const NoResponse = {};
export const getPlpProductData = (state) => {
  return (state.ProductDetail && state.ProductDetail.plpProductData) ?? NoResponse;
};
export const getSlpProductData = (state) => {
  return (state.ProductDetail && state.ProductDetail.slpProductData) ?? NoResponse;
};
export const getCartProductData = (state) => {
  return (state.ProductDetail && state.ProductDetail?.cartProductData) ?? NoResponse;
};
export const getIsPDPCalledViaRecommendation = (state) => {
  return state.ProductDetail && state.ProductDetail.isPDPCalledFromRecommendationFlag;
};
export const getProductListingDetail = (state) => {
  return state && state.ProductListing && state.ProductListing.loadedProductsPages;
};

export const getSearchListingPage = (state) => {
  return state && state.SearchListingPage && state.SearchListingPage.loadedProductsPages;
};

const selectStateForm = (state) => (state && state.form ? state.form : {});
export const getProductDetailFormValues = createSelector(
  selectStateForm,
  getGeneralProductId,
  (stateForm, generalProductId) => {
    return getAddedToBagFormValues(stateForm, `ProductAddToBag-${generalProductId}`);
  }
);

/* We had an issue where generalProductId in PDP was not matching with the QV, for crossBrand products.
 generalProductId from QV actually create the form in redux hence when we try to get the form using
 PDP generalProductId, it was returning undefined. Hence we create this selector to return the correct
 formValues if the product is crossBrand and we are getting formValues carryForwarded from QV. */
/**
 * $brand is only appending in generalProductId when navigating from QV to PDP. In rest of the scenario
 * it is fine.
 */
export const getPdpFormValues = (state) => {
  const generalProductId = getGeneralProductId(state);
  const stateForm = selectStateForm(state);
  return getAddedToBagFormValues(stateForm, `ProductAddToBag-${generalProductId?.split(`$`)[0]}`);
};

export const getAccessoriesData = (state, isSearchPage, isPLP, currentProductData) => {
  let { currentProduct = {} } = state.ProductDetail || {};
  currentProduct = currentProductData || currentProduct;
  let formValues = getProductDetailFormValues(state);
  if (isSearchPage || isPLP) {
    const stateForm = selectStateForm(state);
    currentProduct = currentProductData || currentProduct;
    const { generalProductId } = currentProduct || {};
    formValues = getAddedToBagFormValues(
      stateForm,
      `ProductAddToBag-${generalProductId}`,
      'getAccessoriesData'
    );
  }
  const { allProductId } = currentProduct;
  if (formValues && allProductId) {
    const { color } = formValues;
    const selectedProduct = allProductId.filter((product) => {
      return color === product.auxdescription;
    });
    if (selectedProduct && selectedProduct[0] && selectedProduct[0].accessoriesData) {
      return selectedProduct[0].accessoriesData;
    }
  }
  return currentProduct.accessoriesData;
};

export const getPlpLabelsCopy = (plpLabels) => {
  if (!plpLabels)
    return {
      addToBag: '',
      update: '',
      errorMessage: '',
      size: '',
      fit: '',
      color: '',
      quantity: '',
      sizeUnavalaible: '',
      sizeAvailable: '',
      saveProduct: '',
      sizeChart: '',
      soldOutError: '',
      addToFavorites: '',
      plpRecosProductTilesTitle: '',
      lbl_plp_view_this_look: '',
      lbl_plp_also_available_in: '',
      lbl_accessory_select_add_on: 'lbl_accessory_select_add_on',
      lbl_accessory_update_add_on: 'lbl_accessory_update_add_on',
      lbl_accessory_selected: 'lbl_accessory_selected',
      lbl_add_accessory: 'lbl_add_accessory',
      lbl_update_accessory: 'lbl_update_accessory',
      lbl_remove_accessory: 'lbl_remove_accessory',
      lbl_accessory_price_included: 'lbl_accessory_price_included',
      bossUnavailableError: 'The Store is Currently unavailable for No Rush Pickup',
    };
  const {
    plpTiles: {
      lbl_add_to_bag: addToBag,
      lbl_pdp_update: update,
      lbl_pdp_size_error: errorMessage,
      lbl_pdp_size: size,
      lbl_pdp_fit: fit,
      lbl_pdp_color: color,
      lbl_pdp_quantity: quantity,
      lbl_size_unavailable_online: sizeUnavalaible,
      lbl_other_sizes_available: sizeAvailable,
      lbl_fav_save_product: saveProduct,
      lbl_size_chart: sizeChart,
      lbl_soldout_error: soldOutError,
      lbl_add_to_favorites: addToFavorites,
      lbl_view_details: viewProductDetails,
      lbl_see_similar_items: seeSimilarItems,
      lbl_sold_out: soldOut,
      lbl_plp_recos_producttiles_title: plpRecosProductTilesTitle,
      lbl_plp_also_available_in: alsoAvailableIn,
      lbl_accessory_select_add_on: selectAddOn,
      lbl_accessory_update_add_on: updateAddOn,
      lbl_accessory_selected: accessorySelected,
      lbl_add_accessory: addAccessory,
      lbl_update_accessory: updateAccessory,
      lbl_remove_accessory: removeAccessory,
      lbl_accessory_price_included: accessoryPriceIncluded,
      lbl_boss_unavailable_error: bossUnavailableError,
    } = {},
  } = plpLabels;

  return {
    addToBag,
    errorMessage,
    size,
    fit,
    color,
    quantity,
    update,
    sizeUnavalaible,
    sizeAvailable,
    saveProduct,
    sizeChart,
    soldOutError,
    addToFavorites,
    viewProductDetails,
    seeSimilarItems,
    soldOut,
    plpRecosProductTilesTitle,
    alsoAvailableIn,
    selectAddOn,
    updateAddOn,
    accessorySelected,
    addAccessory,
    updateAccessory,
    removeAccessory,
    accessoryPriceIncluded,
    bossUnavailableError,
  };
};
// TODO - This is temporary - fix it by introducing the image carousel and zoom
export const getDefaultImage = (state) => {
  const firstColor =
    state.ProductDetail.currentProduct &&
    state.ProductDetail.currentProduct.colorFitsSizesMap &&
    state.ProductDetail.currentProduct.colorFitsSizesMap[0] &&
    state.ProductDetail.currentProduct.colorFitsSizesMap[0].color &&
    state.ProductDetail.currentProduct.colorFitsSizesMap[0].color.name;
  return (
    firstColor &&
    state.ProductDetail.currentProduct &&
    state.ProductDetail.currentProduct.imagesByColor &&
    state.ProductDetail.currentProduct.imagesByColor[firstColor]?.basicImageUrl
  );
};

export const getCurrentCurrency = (state) => {
  return state.session.siteDetails.currency;
};

const getSiteDetails = (state) => state.session.siteDetails;

const getDefaultCurrencyAttributes = {
  exchangevalue: 1,
  merchantMargin: 1,
  roundMethod: '',
};

export const getCurrencyAttributes = createSelector(getSiteDetails, (siteDetails) => {
  return (siteDetails && siteDetails.currencyAttributes) || getDefaultCurrencyAttributes;
});

export const getPDPLabelCopy = (pdpLabels) => {
  if (!pdpLabels) {
    return {
      pageNotFound: '',
      fullSize: '',
      viewThisLook: '',
      promoArea1: '',
      promoArea: '',
      promoArea3: '',
      completeTheLook: '',
      youMayAlsoLike: '',
      weFoundTheseSimilarItems: '',
      addToBagPlpDrawer: '',
      checkoutSimilarStyle: '',
      recentlyViewed: '',
      myStylePlace: '',
      ratingReview: '',
      ratingReviewReDesign: '',
      ShowMore: '',
      AllColors: '',
      FavoriteColors: '',
      ShowLess: '',
      ProductDescription: '',
      ViewMore: '',
      ViewLess: '',
      KeyFeatures: '',
      ProductDescriptionNewDesign: '',
      ClaimMessage: '',
      PartNumber: '',
      preferSendingViaEmail: '',
      sendAnEmailCard: '',
      freeShippingEveryDay: '',
      back: '',
      backToResults: '',
      lblPdpSEODesc: '',
      lblPdpPerUnit: '',
      lblPdpProductInclude: '',
      lblPdpMultipackPack: '',
      lblPdpMultipackTitle: '',
      lblPdpMultipackSingle: '',
      lblUnavailableColour: '',
      pointsAndRewardsText: '',
      headingStyleWith: '',
      sizeSelectionLabel: '',
      fitSelectionLabel: '',
      availableInOtherDepartments: '',
      selectSizeErrorText: '',
      addToBag: '',
      selectSizeLabel: '',
      sizeGuide: '',
      reviews: '',
      selectValueLabel: '',
      sizeDrawerValue: '',
      save30: '',
      plccPay: '',
      plccDesc: '',
      plccTerms: '',
      plccDiscription: '',
      myLabel: '',
      placeLabel: '',
      rewardsLabel: '',
      creditCardLabel: '',
      shopSimilar: '',
      learnMoreLabel: '',
      plccMoreDiscription: '',
      tcpLabel: '',
      gymLabel: '',
      snjLabel: '',
      pjpLabel: '',
      miniBagTitleLabel: '',
      viewBagButtonLabel: '',
      changeFitAndSizeLink: '',
      changeSizeLink: '',
      elementsPlccCardImageUrl: '',
      writeReviewLabel: '',
      topRatedBadgeLabel: '',
      bestSellerBadgeLabel: '',
      similarItemToConsider: '',
      recentlyViewedUpdated: '',
      loginLabel: '',
      createAccount: '',
      lblShowInStockStores: '',
    };
  }
  const {
    lbl_page_not_found: pageNotFound,
    lbl_full_size: fullSize,
    lbl_View_this_look: viewThisLook,
    lbl_promo_area_1: promoArea1,
    lbl_promo_area: promoArea,
    lbl_promo_area_3: promoArea3,
    lbl_complete_the_look: completeTheLook,
    lbl_you_may_also_like: youMayAlsoLike,
    lbl_we_found_these_similar_items: weFoundTheseSimilarItems,
    lbl_add_to_bag_plp_drawer_redesign: addToBagPlpDrawer,
    lbl_pdp_pla_abtest: checkoutSimilarStyle,
    lbl_recently_viewed: recentlyViewed,
    lbl_my_style_place: myStylePlace,
    lbl_rating_review: ratingReview,
    lbl_rating_review_redesign: ratingReviewReDesign,
    lbl_product_description_show_more: ShowMore,
    lbl_product_description_all_colors: AllColors,
    lbl_product_description_favorite_colors: FavoriteColors,
    lbl_product_description_show_less: ShowLess,
    lbl_product_description_label: ProductDescription,
    lbl_view_more: ViewMore,
    lbl_view_less: ViewLess,
    lbl_key_features: KeyFeatures,
    lbl_product_description_label_redesign: ProductDescriptionNewDesign,
    lbl_product_description_claim_message: ClaimMessage,
    lbl_product_description_item_part_number: PartNumber,
    lbl_prefer_sending_via_email: preferSendingViaEmail,
    lbl_send_an_email_card: sendAnEmailCard,
    lbl_back_to_results: backToResults,
    lbl_pdp_per_unit: lblPdpPerUnit,
    lbl_product_include_text: lblPdpProductInclude,
    lbl_multipack_pack_text: lblPdpMultipackPack,
    lbl_multipack_pack_title: lblPdpMultipackTitle,
    lbl_multipack_single_text: lblPdpMultipackSingle,
    lbl_unavailable_color: lblUnavailableColour,
    lbl_brierley_promo_text_generic: pointsAndRewardsText,
    lbl_size_heading_redesign: sizeSelectionLabel,
    lbl_fit_heading_redesign: fitSelectionLabel,
    lbl_available_in_other_departments: availableInOtherDepartments,
    lbl_select_size_error_text: selectSizeErrorText,
    lbl_add_to_bag: addToBag,
    lbl_select_size_label: selectSizeLabel,
    lbl_size_guide_redesign: sizeGuide,
    lbl_reviews_redesign: reviews,
    lbl_gift_card_select_value_redesign: selectValueLabel,
    lbl_gift_card_value_redesign: sizeDrawerValue,
    lbl_plcc_banner_save30: save30,
    lbl_plcc_banner_pay: plccPay,
    lbl_plcc_banner_desc: plccDesc,
    lbl_plcc_banner_terms_apply: plccTerms,
    lbl_plcc_banner_discription: plccDiscription,
    lbl_plcc_banner_my: myLabel,
    lbl_plcc_banner_place: placeLabel,
    lbl_plcc_banner_rewards: rewardsLabel,
    lbl_plcc_banner_discription_open: plccMoreDiscription,
    lbl_pjp: pjpLabel,
    lbl_mini_bag_title: miniBagTitleLabel,
    lbl_view_bag_btn: viewBagButtonLabel,
    lbl_change_fit_and_size: changeFitAndSizeLink,
    lbl_change_size: changeSizeLink,
    lbl_plcc_brand_image_path_pjp: elementsPlccCardImageUrl,
    lbl_write_review: writeReviewLabel,
    lbl_similar_items: similarItemToConsider,
    lbl_you_recently_viewed: recentlyViewedUpdated,
    lbl_header_login: loginLabel,
    lbl_create_an_account: createAccount,
    lbl_best_seller: bestSellerBadgeLabel,
    lbl_TCPBazaarVoiceRating: topRatedBadgeLabel,
    lbl_show_in_stock_stores: lblShowInStockStores,
  } = pdpLabels;

  return {
    pageNotFound,
    fullSize,
    viewThisLook,
    promoArea1,
    promoArea,
    promoArea3,
    completeTheLook,
    youMayAlsoLike,
    weFoundTheseSimilarItems,
    addToBagPlpDrawer,
    checkoutSimilarStyle,
    recentlyViewed,
    myStylePlace,
    ratingReview,
    ratingReviewReDesign,
    ShowMore,
    AllColors,
    FavoriteColors,
    ShowLess,
    ProductDescription,
    ViewMore,
    ViewLess,
    KeyFeatures,
    ProductDescriptionNewDesign,
    ClaimMessage,
    PartNumber,
    preferSendingViaEmail,
    sendAnEmailCard,
    backToResults,
    lblPdpPerUnit,
    lblPdpProductInclude,
    lblPdpMultipackPack,
    lblPdpMultipackTitle,
    lblPdpMultipackSingle,
    lblUnavailableColour,
    pointsAndRewardsText,
    sizeSelectionLabel,
    fitSelectionLabel,
    availableInOtherDepartments,
    selectSizeErrorText,
    addToBag,
    selectSizeLabel,
    sizeGuide,
    reviews,
    selectValueLabel,
    sizeDrawerValue,
    save30,
    plccPay,
    plccDesc,
    plccTerms,
    plccDiscription,
    myLabel,
    placeLabel,
    rewardsLabel,
    plccMoreDiscription,
    pjpLabel,
    miniBagTitleLabel,
    viewBagButtonLabel,
    changeFitAndSizeLink,
    changeSizeLink,
    elementsPlccCardImageUrl,
    writeReviewLabel,
    similarItemToConsider,
    recentlyViewedUpdated,
    loginLabel,
    createAccount,
    bestSellerBadgeLabel,
    topRatedBadgeLabel,
    lblShowInStockStores,
  };
};

const getLayouts = (state) => {
  return state.Layouts;
};

const getModulesState = (state) => {
  return state.Modules;
};

const getIsTopPromoEnabled = (state) => {
  return getABtestFromState(state.AbTest).pdpTopPromo;
};

const getIsMiddlePromoEnabled = (state) => {
  return getABtestFromState(state.AbTest).pdpMiddlePromo;
};

const getIsBottomPromoEnabled = (state) => {
  return getABtestFromState(state.AbTest).pdpBottomPromo;
};

const getIsBelowrecsPromoEnabled = (state) => {
  return getABtestFromState(state.AbTest).pdpBelowrecsPromo;
};

export const getCategory = (state) =>
  state &&
  state.ProductDetail &&
  state.ProductDetail.currentProduct &&
  state.ProductDetail.currentProduct.category;

const getUserType = (isUserGuest, isUserPlcc) => {
  let userType = 'mpr';
  if (isUserGuest || isServer()) {
    userType = 'guest';
  } else if (isUserPlcc) {
    userType = 'plcc';
  }
  return userType;
};

const getPromo = (promos, userType) => {
  let isNewPromo = false;
  const filteredPromos = Array.isArray(promos)
    ? promos.filter((slot) => {
        const userTier = slot && slot.userType;
        if (userTier) isNewPromo = userTier;
        return userTier === userType;
      })
    : null;
  return isNewPromo ? filteredPromos : promos;
};

export const getPDPTopPromos = createSelector(
  getLayouts,
  getModulesState,
  getCategory,
  getIsGuest,
  isPlccUser,
  getIsTopPromoEnabled,
  (Layouts, Modules, primaryCategory, isUserGuest, isUserPlcc, isTopPromoEnabled) => {
    if (!isTopPromoEnabled) return null;
    const type = PRODUCTDETAIL_CONSTANTS.PROMO_TOP;
    let result = null;
    if (Layouts && Layouts.pdp && primaryCategory) {
      const { pdp } = Layouts;
      const promoCatId = pdp[primaryCategory] ? primaryCategory : 'global';
      if (pdp[promoCatId]) {
        const promos = pdp[promoCatId][type] && pdp[promoCatId][type].slots;
        const userType = getUserType(isUserGuest, isUserPlcc);
        const promo = getPromo(promos, userType);
        result =
          (promo &&
            promo.map((promoItem) => {
              return (promoItem.contentId && Modules[promoItem.contentId]) || {};
            })) ||
          [];
      }
    }
    return result;
  }
);

export const getPDPMiddlePromos = createSelector(
  getLayouts,
  getModulesState,
  getCategory,
  getIsGuest,
  isPlccUser,
  getIsMiddlePromoEnabled,
  (Layouts, Modules, primaryCategory, isUserGuest, isUserPlcc, isMiddlePromoEnabled) => {
    if (!isMiddlePromoEnabled) return null;
    const type = PRODUCTDETAIL_CONSTANTS.PROMO_MIDDLE;
    let result = null;
    if (Layouts && Layouts.pdp && primaryCategory) {
      const { pdp } = Layouts;
      const promoCatId = pdp[primaryCategory] ? primaryCategory : 'global';
      if (pdp[promoCatId]) {
        const promos = pdp[promoCatId][type] && pdp[promoCatId][type].slots;
        const userType = getUserType(isUserGuest, isUserPlcc);
        const promo = getPromo(promos, userType);
        result =
          (promo &&
            promo.map((promoItem) => {
              return (promoItem.contentId && Modules[promoItem.contentId]) || {};
            })) ||
          [];
      }
    }
    return result;
  }
);

export const getPDPBottomPromos = createSelector(
  getLayouts,
  getModulesState,
  getCategory,
  getIsGuest,
  isPlccUser,
  getIsBottomPromoEnabled,
  (Layouts, Modules, primaryCategory, isUserGuest, isUserPlcc, isBottomPromoEnabled) => {
    if (!isBottomPromoEnabled) return null;

    const type = PRODUCTDETAIL_CONSTANTS.PROMO_BOTTOM;
    let result = null;
    if (Layouts && Layouts.pdp && primaryCategory) {
      const { pdp } = Layouts;
      const promoCatId = pdp[primaryCategory] ? primaryCategory : 'global';
      if (pdp[promoCatId]) {
        const promos = pdp[promoCatId][type] && pdp[promoCatId][type].slots;
        const userType = getUserType(isUserGuest, isUserPlcc);
        const promo = getPromo(promos, userType);
        result =
          (promo &&
            promo.map((promoItem) => {
              return (promoItem.contentId && Modules[promoItem.contentId]) || {};
            })) ||
          [];
      }
    }
    return result;
  }
);

export const getPDPBelowRecsPromos = createSelector(
  getLayouts,
  getModulesState,
  getCategory,
  getIsGuest,
  isPlccUser,
  getIsBelowrecsPromoEnabled,
  (Layouts, Modules, primaryCategory, isUserGuest, isUserPlcc, isBelowrecsPromoEnabled) => {
    if (!isBelowrecsPromoEnabled) return null;

    const type = PRODUCTDETAIL_CONSTANTS.PROMO_BELOWRECS;
    let result = null;
    if (Layouts && Layouts.pdp && primaryCategory) {
      const { pdp } = Layouts;
      const promoCatId = pdp[primaryCategory] ? primaryCategory : 'global';
      if (pdp[promoCatId]) {
        const promos = pdp[promoCatId][type] && pdp[promoCatId][type].slots;
        const userType = getUserType(isUserGuest, isUserPlcc);
        const promo = getPromo(promos, userType);
        result =
          (promo &&
            promo.map((promoItem) => {
              return (promoItem.contentId && Modules[promoItem.contentId]) || {};
            })) ||
          [];
      }
    }
    return result;
  }
);

export const getDynamicContentPromo = createSelector(
  getLayouts,
  getModulesState,
  getCategory,
  getIsGuest,
  isPlccUser,
  getDynamicContentPDP,
  (Layouts, Modules, primaryCategory, isUserGuest, isUserPlcc, isDynamicContentPDPEnabled) => {
    if (!isDynamicContentPDPEnabled) return null;

    const type = PRODUCTDETAIL_CONSTANTS.PROMO_PDP_DYNAMIC;
    let result = null;
    if (Layouts && Layouts.pdp && primaryCategory) {
      const { pdp } = Layouts;
      const promoCatId = pdp[primaryCategory] ? primaryCategory : 'global';
      if (pdp[promoCatId]) {
        const promos = pdp[promoCatId][type] && pdp[promoCatId][type].slots;
        const userType = getUserType(isUserGuest, isUserPlcc);
        const promo = getPromo(promos, userType);
        result =
          (promo &&
            promo.map((promoItem) => {
              return (promoItem.contentId && Modules[promoItem.contentId]) || {};
            })) ||
          [];
      }
    }
    return result;
  }
);

const getRefinedNavTree = (catId, navigationTree) => {
  return navigationTree.find((L1) => L1.categoryId === catId);
};

const getRefinedNavTreeL2orL3 = (catId, navigationTree) => {
  return (navigationTree && navigationTree.find((L2) => L2.categoryContent.id === catId)) || [];
};

const getCatMapL1Params = (catMapL1) => {
  const menuItems = [];
  const mainObj = catMapL1 && catMapL1.subCategories;
  let returnValue = [];
  if (mainObj) {
    Object.keys(mainObj).forEach((key) => {
      menuItems.push(mainObj[key].items);
    });
    try {
      returnValue = menuItems.flat(2);
    } catch (err) {
      returnValue = [];
    }
  }
  return returnValue;
};

const getCatMapL2 = (catMapL2Id, catMapL1Params) => {
  return (catMapL2Id && getRefinedNavTreeL2orL3(catMapL2Id, catMapL1Params)) || [];
};

const getNavTreeFromCatMap = (navTree, categoryPath) => {
  if (!categoryPath) return '';
  const catMapL1Id = categoryPath[0] && categoryPath[0].split('|')[0].split('>')[0];
  const catMapL2Id = categoryPath[0] && categoryPath[0].split('|')[0].split('>')[1];
  const catMapL3Id = (categoryPath[0] && categoryPath[0].split('|')[0].split('>')[2]) || null;
  const catMapL1 = catMapL1Id && getRefinedNavTree(catMapL1Id, navTree);
  const catMapL1Params = getCatMapL1Params(catMapL1);
  const catMapL2 = getCatMapL2(catMapL2Id, catMapL1Params);
  return (
    (catMapL3Id && getRefinedNavTreeL2orL3(catMapL3Id, catMapL2 && catMapL2.subCategories)) ||
    catMapL2
  );
};

const getCatMapFromBreadCrump = (categoryPath, breadCrumbs) => {
  return (
    categoryPath &&
    breadCrumbs[1] &&
    categoryPath.find((_catMap) => _catMap.split('|')[0].includes(breadCrumbs[1].categoryId))
  );
};

const getSizeChartSel = (l3CatFromString) => {
  return (
    l3CatFromString &&
    l3CatFromString.categoryContent &&
    l3CatFromString.categoryContent.sizeChartSelection
  );
};

const getNavTreeFromBreadCrumb = (breadCrumbs, categoryPath, navTree) => {
  const catMap = getCatMapFromBreadCrump(categoryPath, breadCrumbs);
  const l3String = catMap ? catMap.split('|')[0].split('>')[2] || '' : '';
  const l3CatFromString =
    navTree &&
    navTree.subCategories &&
    navTree.subCategories.map((navMap) => {
      return navMap.items.find((cat) => cat.id === l3String);
    });

  return (
    getSizeChartSel(l3CatFromString) ||
    (navTree && navTree.categoryContent && navTree.categoryContent.sizeChartSelection) ||
    ''
  );
};

const fetchL2andL3Category = (navTree, breadCrumbs, isBundleProduct, categoryPath) => {
  let l3Cat = {};
  let l2Cat = {};
  if (breadCrumbs && breadCrumbs[0] && breadCrumbs[0].categoryId && !isBundleProduct) {
    const tree = getRefinedNavTree(breadCrumbs[0].categoryId, navTree);
    l2Cat =
      tree &&
      tree.subCategories &&
      tree.subCategories.map((navMap) => {
        return navMap.items.find((cat) => cat.id === breadCrumbs[1].categoryId);
      });

    l3Cat =
      breadCrumbs[2] &&
      l2Cat &&
      l2Cat.subCategories &&
      l2Cat.subCategories.find((cat) => cat.categoryId === breadCrumbs[2].categoryId);
  } else {
    l3Cat = getNavTreeFromCatMap(navTree, categoryPath);
  }
  return { l2Cat, l3Cat };
};

// Disabling eslint for temporary fix
// eslint-disable-next-line no-unused-vars
const fetchSizeChartDetails = (navTree, breadCrumbs, categoryPath, isBundleProduct) => {
  // Return empty if Navigation Tree not available/passed
  if (!navTree) {
    return '';
  }
  const payload = fetchL2andL3Category(navTree, breadCrumbs, isBundleProduct, categoryPath);
  if (payload.l3Cat) {
    return (
      (payload.l3Cat.categoryContent && payload.l3Cat.categoryContent.sizeChartSelection) ||
      (payload.l2Cat &&
        payload.l2Cat.categoryContent &&
        payload.l2Cat.categoryContent.sizeChartSelection) ||
      ''
    );
  }
  return getNavTreeFromBreadCrumb(breadCrumbs, categoryPath, payload.l2Cat);
};

// Disabling eslint for temporary fix
// eslint-disable-next-line no-unused-vars
export const getSizeChartDetails = (state) => {
  const breadCrumbs = processBreadCrumbs(state.ProductDetail && state.ProductDetail.breadCrumbs);
  const navigationTree = state.Navigation && state.Navigation.navigationData;
  const isBundleProduct =
    state.ProductDetail &&
    state.ProductDetail.currentProduct &&
    state.ProductDetail.currentProduct.bundleProducts &&
    state.ProductDetail.currentProduct.bundleProducts.length > 0;
  const categoryPathMap =
    state.ProductDetail &&
    state.ProductDetail.currentProduct &&
    state.ProductDetail.currentProduct.categoryPathMap;
  return fetchSizeChartDetails(navigationTree, breadCrumbs, categoryPathMap, isBundleProduct);
};

export const getAccessibilityLabelsCopy = (accessibilityLabels) => {
  if (!accessibilityLabels) {
    return {
      previousPrice: '',
      rating: '',
      outOf: '',
      lbl_social_twitter: '',
      lbl_social_facebook: '',
      lbl_social_pinterest: '',
      lbl_up_arrow_icon: '',
      lbl_down_arrow_icon: '',
      lbl_show_page: '',
      lbl_product_image: '',
      lbl_product_hint: '',
    };
  }
  const {
    lbl_previous_price: previousPrice,
    lbl_rating: rating,
    lbl_out_of: outOf,
    ...otherLabels
  } = accessibilityLabels;

  return {
    previousPrice,
    rating,
    outOf,
    ...otherLabels,
  };
};

export const getOnModelImageAbTestPdp = (state) => {
  return getABtestFromState(state.AbTest).enableOnModelImageOnPDP;
};

export const isValidProduct = (state) => {
  const currentProduct = getCurrentProduct(state);
  return currentProduct && !!currentProduct.unbxdProdId;
};

export const getPageUrl = (state) => {
  return state.ProductDetail.pageUrl;
};

export const getUpdatedCount = (state) => {
  return state && state.ProductDetail && state.ProductDetail.countUpdated;
};

export const getStyliticsProductTabListSelector = (state) => {
  const { StyliticsProductTabList } = state;
  return StyliticsProductTabList;
};

export const getPriceDisplayState = (state) => {
  return state && state.ProductDetail && state.ProductDetail.hidePriceDisplay;
};

export const getDynamicContentLoader = (state) => {
  return state && state.ProductDetail && state.ProductDetail.showDynamicContentLoader;
};

export const getIsAbPdpPlaEnabled = (state) => {
  return getABtestFromState(state.AbTest).isAbPdpPlaEnabled;
};

export const getIsVisualSimilarStylesEnabled = (state) => {
  return getABtestFromState(state.AbTest).isVisualSimilarStylesEnabled;
};

export const getIsOosPdpEnabled = (state) => {
  return getABtestFromState(state.AbTest).isOosPdpEnabled;
};

export const getIsPdp1andPdp2Enabled = (state) => {
  return getABtestFromState(state.AbTest).isPdp1andPdp2Enabled;
};

export const getPdpNewRecommendation = (state) => {
  return getABtestFromState(state.AbTest).PDP_NEW_RECOMMENDATION;
};

export const getSelectedSizeDisabled = (state) => {
  return state && state.ProductDetail && state.ProductDetail.selectedSizeStatus;
};

export const getIsSidebarMounted = (state) => {
  return state && state.ProductDetail && state.ProductDetail.isSidebarMounted;
};

export const getIsTakeDownProduct = (state) => {
  return (
    state &&
    state.ProductDetail &&
    state.ProductDetail.currentProduct &&
    state.ProductDetail.currentProduct.isTakeDownProduct
  );
};

export const getTakeDownCategory = (state) => {
  return (
    state &&
    state.ProductDetail &&
    state.ProductDetail.currentProduct &&
    state.ProductDetail.currentProduct.takeDownCategory
  );
};

export const getSizeChartModuleXContentId = (brand = 'tcp') => {
  const helpCenterLabels = getDynamicLabelValues('global.helpCenter');
  let contentID;
  if (helpCenterLabels && Array.isArray(helpCenterLabels.referred)) {
    contentID =
      helpCenterLabels.referred.length &&
      helpCenterLabels.referred.find((label) => label.name === `size_chart_modulex_${brand}`);
  }
  return contentID;
};

export const getAdditionalPromoModuleXContentId = () => {
  const dynamicBrowseLabels = getDynamicLabelValues('dynamic.browse_d');
  let contentID;
  if (dynamicBrowseLabels && Array.isArray(dynamicBrowseLabels?.referred)) {
    contentID =
      dynamicBrowseLabels.referred.length &&
      dynamicBrowseLabels.referred.find((label) => label.name === `additional_promo_pdp`);
  }
  return contentID;
};

export const getAdditionalPromoModuleXContent = (state) => {
  return state?.ProductDetail?.additionalPromoModuleXContent;
};

export const getShippingAndReturnsModuleXContentID = () => {
  const pdplbls = getDynamicLabelValues('ProductDetailPage.PDP_Sub');
  let contentID;
  if (pdplbls && Array.isArray(pdplbls?.referred)) {
    contentID =
      pdplbls.referred.length &&
      pdplbls.referred.find((label) => label.name === `shipping_and_returns`);
  }
  return contentID;
};

export const getShippingAndReturnsModuleXContent = (state) => {
  return state?.ProductDetail?.shippingAndReturnsModuleXContent;
};

export const getSizeChartModuleXContent = (state, brand = 'tcp') => {
  return state?.ProductDetail?.sizeChartModuleX?.[brand];
};

// isHplp is for Hplp filters, to carry fwd the applied filters to PDP.
export const getAppliedFiltersfromPLP = createSelector(
  getAppliedFilters,
  getCategoryListingFilters,
  getIsFromCategoryPage,
  isHplp,
  getHplpAppliedFilters,
  (
    appliedFilters,
    categoryAppliedFilters,
    isFromCategoryPage,
    isFromHplp,
    horizontalAppliedFilter
  ) => {
    if (isFromHplp && isFromCategoryPage) return horizontalAppliedFilter;
    if (isFromCategoryPage) return categoryAppliedFilters;
    return appliedFilters;
  }
);

export const getSyteScriptLoaded = (state) => {
  return state.ProductDetail && state.ProductDetail.isSyteScriptLoaded;
};

const getNavigation = (state) => state?.Navigation?.navigationData;

export const newBreadcrumbs = (primaryCategoryId) =>
  createSelector(getNavigation, (navData) => {
    return processHelperUtil.getCurrentNavCat(navData, primaryCategoryId);
  });

export const getScrollToIndex = (state) => state?.ProductDetail?.scrollToIndex;

export const getIsDeptClicked = (state) => state?.ProductDetail?.isDeptClicked ?? false;

export const getIsStickyAtbHeaderLoaded = (state) => state?.ProductDetail?.isStickyATBLoaded;
